import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';
import { UserStatus } from './enums/UserStatus';
import { UserRole } from './enums/UserRole';

export class User {
  id: number;

  username: string;

  @Expose({ name: 'first_name' })
  firstname: string;

  @Expose({ name: 'last_name' })
  lastname?: string;

  avatar?: string;

  status: UserStatus;

  @Expose({ name: 'role_id' })
  role: UserRole;

  @Expose({ name: 'date_format' })
  dateFormat: string;

  @Expose({ name: 'customer_id' })
  customerId?: number;

  @Expose({ name: 'referral_link' })
  referralLink?: string;

  email?: string;

  @Expose({ name: 'country_id' })
  countryId: number;

  constructor(
    id: number,
    username: string,
    firstname: string,
    lastname: string | undefined,
    avatar: string | undefined,
    status: UserStatus,
    role: UserRole,
    dateFormat: string,
    customerId: number | undefined,
    referralLink: string | undefined,
    email: string | undefined,
    countryId: number
  ) {
    this.id = id;
    this.username = username;
    this.firstname = firstname;
    this.lastname = lastname;
    this.avatar = avatar;
    this.status = status;
    this.role = role;
    this.dateFormat = dateFormat;
    this.customerId = customerId;
    this.referralLink = referralLink;
    this.email = email;
    this.countryId = countryId;
  }

  static fromJson(json: Record<string, any>): User {
    return plainToInstance(User, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }

  copyWith({
    id = this.id,
    username = this.username,
    firstname = this.firstname,
    lastname = this.lastname,
    avatar = this.avatar,
    status = this.status,
    role = this.role,
    dateFormat = this.dateFormat,
    customerId = this.customerId,
    referralLink = this.referralLink,
    email = this.email,
    countryId = this.countryId,
  }: Partial<User> = {}): User {
    return new User(
      id,
      username,
      firstname,
      lastname,
      avatar,
      status,
      role,
      dateFormat,
      customerId,
      referralLink,
      email,
      this.countryId
    );
  }

  get fullname(): string {
    return [this.firstname, this.lastname?.trim()].filter(Boolean).join(' ');
  }
}
